import { usHolidays } from "./holidays";

// Remembered per browser so the admin doesn't re-tick the same closures every
// year. Storage can be missing or throw (private mode, blocked site data), so
// every access falls back to the defaults.
const CLOSURES_KEY = "holidayClosures";
const PHONE_KEY = "holidayPhone";

export function defaultClosures(): string[] {
  return usHolidays(2000)
    .filter((h) => h.closedByDefault)
    .map((h) => h.name);
}

export function loadHolidayClosures(): string[] {
  try {
    const raw = localStorage.getItem(CLOSURES_KEY);
    if (raw) {
      const parsed: unknown = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.filter((n): n is string => typeof n === "string");
    }
  } catch {
    // fall through to defaults
  }
  return defaultClosures();
}

export function saveHolidayClosures(names: string[]): void {
  try {
    localStorage.setItem(CLOSURES_KEY, JSON.stringify(names));
  } catch {
    // not remembered; still works for this session
  }
}

export function loadHolidayPhone(): string {
  try {
    return localStorage.getItem(PHONE_KEY) ?? "";
  } catch {
    return "";
  }
}

export function saveHolidayPhone(phone: string): void {
  try {
    localStorage.setItem(PHONE_KEY, phone);
  } catch {
    // not remembered; still works for this session
  }
}
